import Axios from 'axios';
import LocalForage from 'localforage';
let hasPermsModels = true;

let isError403 = function(error){
    return (
        error.status === 403 ||
        error.toString().includes('request canceled') ||
        error.toString().includes('Request failed with status code 403')
    );
};

let isError404 = function(error){
    return (
        error.status === 404 ||
        error.toString().includes('Request failed with status code 404')
    );
};

let isError500 = function(error){
    return (
        error.status === 500 ||
        error.status === 502 ||
        error.status === 503 ||
        error.toString().includes('status code 500') ||
        error.toString().includes('status code 502') ||
        error.toString().includes('status code 503') ||
        error.toString().includes('Network Error')
    );
};

let wait = async function(seconds){
    return new Promise(resolve => {
        setTimeout(resolve, seconds * 1000);
    });
};

let ensureApiUrlIsAbsolute = (url) => {
    // patch tant que le probleme d'url relative
    // des object nested n'a pas été résolu sur concrete
    let regex = /^\/api\/v\d+(\.\d+)?\//;
    let relativeUrl = url.match(regex);
    if(relativeUrl){
        url = url.replace(relativeUrl[0], '');
    }
    return url;
};


export default {

    addMetaModel({commit, getters, state}, modelName) {
        if (state.meta.listModels[`${modelName}s`] === undefined) {
            commit('ADD_META_MODEL', modelName);
            commit('ADD_STORE_ENTRIES', `${modelName}s`);
            getters[`${modelName}s`] = state[`${modelName}sList`].map( objId => state[`${modelName}s`][objId]);
            getters[`${modelName}sByCreationDate`] = () => {
                return getters.getCollectionSorted(
                    getters[`${modelName}s`], 'creation_date'
                );
            };
            getters[`${modelName}sByModificationDate`] = () => {
                return getters.getCollectionSorted(
                    getters[`${modelName}s`], 'modification_date'
                );
            };
            getters[`${modelName}sByUid`] = () => objId => state[`${modelName}s`][objId];

        }
        return;
    },
    removeMetaModel({commit, getters, state}, modelName) {
        if (state.meta.listModels[`${modelName}s`] && state.meta.listModels[`${modelName}s`].forced) {
            delete getters[`${modelName}sByUid`];
            delete getters[`${modelName}sByModificationDate`];
            delete getters[`${modelName}sByCreationDate`];
            delete getters[`${modelName}s`];
            commit('REMOVE_STORE_ENTRIES', `${modelName}s`);
            commit('REMOVE_META_MODEL', modelName);
        }
        return;
    },

    async setScope({commit, dispatch}, scopes){
        commit('SET_SCOPE', scopes);
        return dispatch('reloadScopedModels');
    },

    async clearModels ({state, commit, dispatch}, listModels=null){
        if(listModels === null){
            listModels = state.meta.listModels;
        }
        for(let modelName in listModels){
            // retrieve value of key `public` setted in the meta.js
            // when public === true the model won't be cleared
            let modelIsPublic = listModels[modelName].public;
            if (modelIsPublic !== true) {
                dispatch('cancelFetchModelPeriodically', modelName);
                commit('RESET_MODEL_VALUES', modelName);
            }
        }
    },

    async loadModels ({state, dispatch}, listModels=null){
        let models = {};
        if(listModels === null){
            listModels = state.meta.listModels;
        }
        for(let modelName in listModels){
            // Does not fetch only if explicit key fetch set to false
            if(listModels[modelName].fetch !== false){
                models[modelName] = listModels[modelName];
            }
        }
        return dispatch('fetchModelsPeriodically', models);
    },

    async reloadModels ({state, dispatch}, listModels=null){
        if(listModels === null){
            listModels = state.meta.listModels;
        }
        await dispatch('clearModels', listModels);
        await dispatch('loadModels', listModels);
    },

    async reloadScopedModels ({state, dispatch}){
        let models = {};
        let listModels = state.meta.listModels;
        for(let modelName in listModels){
            // Model scoped only if explicit key scoped set to true
            if(listModels[modelName].scoped === true){
                models[modelName] = listModels[modelName];
            }
        }
        return dispatch('reloadModels', models);
    },

    async createItem(context, {item, model, url, scopes=null}) {
        delete item.uid;
        const config = {
            headers: scopes || {},
        };
        return this.axios.post(url, item, config).then(response => {
            let addItemData = {
                modelName: model,
                item: response.data
            };
            if(context.state.meta.listModels[model].fetch !== false){
                context.commit('ADD_ITEM', addItemData);
            }
            return Promise.resolve(response.data);
        });
    },
    async unblockUsers(context, item) {
        return this.axios.post('unblock-users', item);
    },
    async updateItem(context, {item, model}) {
        item.url = ensureApiUrlIsAbsolute(item.url);
        return this.axios.put(item.url, item).then(response => {
            let editItemData = {
                modelName: model,
                item: response.data
            };
            if(context.state.meta.listModels[model].fetch !== false){
                context.commit('EDIT_ITEM', editItemData);
            }
            return Promise.resolve(response.data);
        });
    },
    async patchItem(context, {item, model}) {
        // necessary to force url for selfUser model in order to update API
        if(model === 'selfUser'){
            item.url = ensureApiUrlIsAbsolute('/account/me/');
        }
        else{
            item.url = ensureApiUrlIsAbsolute(item.url);
        }
        return this.axios.patch(item.url, item).then(response => {
            let editItemData = {
                modelName: model,
                item: response.data
            };

            if(model === 'selfUser'){
                context.commit('UPDATE_SELF_USER', response.data);
            }else{
                if(context.state.meta.listModels[model].fetch !== false){
                    context.commit('EDIT_ITEM', editItemData);
                }
            }
            return Promise.resolve(response.data);
        });
    },
    async patchItemFormData(context, {url, item, model}) {
        item.url = ensureApiUrlIsAbsolute(url);
        return this.axios.patch(
            url,
            item,
            {headers: {
                'Content-Type': 'multipart/form-data',
            }}
        ).then(response => {
            let editItemData = {
                modelName: model,
                item: response.data
            };
            if(context.state.meta.listModels[model].fetch !== false){
                context.commit('EDIT_ITEM', editItemData);
            }
            return Promise.resolve(response.data);
        });
    },
    async deleteItem(context, {item, model}) {
        item.url = ensureApiUrlIsAbsolute(item.url);
        return this.axios.delete(item.url).then(() => {
            let deleteItem = {
                modelName: model,
                itemUid: item.uid
            };
            if(context.state.meta.listModels[model].fetch !== false){
                context.commit('DELETE_ITEM', deleteItem);
            }
        });
    },

    async initialFetchModels({getters, dispatch}){
        if(getters.userIsAuthenticated){
            dispatch('fetchCurrentUserPeriodically');
        }
        return dispatch('loadModels');
    },

    async listModels(context, {url, filters, scope, isStats=false}){
        let defaultFilters = {
            c_resp_nested: 'false',
            c_resp_page_size: 250,
            timestamp_start: '0.0'
        };
        let params = Object.assign({}, defaultFilters, filters || {});
        let queryParams = context.getters.queryParams(params);
        let request = {
            url: `${url}${queryParams}`,
            scopes: scope || {}
        };

        let reponse = null;
        try{
            if(isStats){
                reponse = context.dispatch('remoteGet', {
                    url : `${url}stats/${queryParams}`,
                    config: {headers: request.scopes || {}}
                });
            }else{
                reponse = await context.dispatch('unpaginateResponse', request);
            }
        }
        catch(error){
            return;
        }
        return reponse;
    },

    async fetchModelByName(context, modelName){
        if(modelName === 'concretePermissions'){
            if(!context.rootGetters['fundation/shouldFetchModelAclPermissions']){
                return;
            }
        }
        if(modelName === 'concreteRoles'){
            if(!context.rootGetters['fundation/shouldFetchModelAclRoles']){
                return;
            }
        }
        let meta = context.state.meta.listModels[modelName];


        if(['Concrete permission', 'Concrete role'].includes(meta.verboseName) && !hasPermsModels){
            return;
        }

        if(meta === undefined){
            throw new Error(`${modelName} not in meta`);
        }

        if(meta.scoped && context.state.scopes === null){
            return;
        }
        let timestamp = context.state.modelsTimestamps[modelName] || '0.0';

        let filters = Object.assign({}, {timestamp_start: timestamp}, meta.filter);
        let response = await context.dispatch(
            'listModels',
            {
                url: meta.url,
                filters: filters,
                scope: (meta.scoped)? context.state.scopes : {},
                isStats: meta.stats,
            }
        );
        await context.dispatch('updateItemsStored', {
            response,
            meta,
            modelName
        });
        return;
    },

    async updateItemsStored (context, { response, meta, modelName, isMeta=true, filterHashed='', scopes}){
        // on ne traite pas ici les response ignorées
        if(response !== undefined && response !== 'ignored'){
            if(meta.stats){
                context.commit('UPDATE_STATS_MODEL', {
                    modelName: modelName,
                    count: response.data.objects_count
                });
                context.commit(
                    'UPDATE_MODEL_LOADING_STATUS', {
                        modelName: modelName,
                        status: true
                    }
                );
                return Promise.resolve();
            }
            let updateMutation = isMeta ? 'UPDATE_LIST' : 'nsLoaderStore/UPDATE_LIST';
            let updateTimestamp = isMeta ? 'UPDATE_MODEL_TIMESTAMP' : 'nsLoaderStore/UPDATE_MODEL_TIMESTAMP';
            let removeDeletedModels = isMeta ? 'REMOVE_DELETED_MODELS' : 'nsLoaderStore/REMOVE_DELETED_MODELS';

            context.commit(
                updateMutation, {
                    modelName: modelName,
                    list: response.results,
                    filterHashed: filterHashed,
                    scopes: scopes,
                }
            );
            context.commit(
                updateTimestamp, {
                    modelName: modelName,
                    timestamp: response.timestamp_end,
                    filterHashed: filterHashed,
                    scopes: scopes,
                }
            );
            context.commit(
                removeDeletedModels, {
                    modelName: modelName,
                    deletedModelUid: response.deleted_uids,
                    filterHashed: filterHashed,
                    scopes: scopes,
                }
            );
            if(isMeta){
                context.commit(
                    'UPDATE_MODEL_LOADING_STATUS', {
                        modelName: modelName,
                        status: true
                    }
                );
            }
            // Dans le cas ou la clé persistent est renseigné sur un model, les donées sont stocké dans le local storage avec le plugin localforage
            if(meta.persistent){
                context.commit(
                    'UPDATE_LOCAL_STORAGE', {
                        modelName: modelName,
                        deletedModelUid: response.deleted_uids,
                        list: response.results,
                        timestamp: response.timestamp_end
                    }
                );
            }
        }else if(response === 'ignored' && isMeta){
            // si un model est ignoré on sette juste comme quoi on l'a bien fetché pour gardé le bon fonctionnement de l'appli
            context.commit(
                'UPDATE_MODEL_LOADING_STATUS', {
                    modelName: modelName,
                    status: true
                }
            );
        }

        return Promise.resolve();
    },

    async unpaginateResponse (context, {url, scopes=null}){
        return new Promise(async (resolve) => {

            let promises = [];
            let results = [];
            let deleted_uids = [];
            let timestamp_end = 0.0;

            const config = {headers: scopes || {}};

            let response = await context.dispatch('remoteGet', {url, config});
            // si la reponse est ignored on la renvoi direct et on fait pas la suite
            if(response === 'ignored'){
                resolve(response);
                return;
            }
            if (response.status === 204) {
                resolve('ignored');
                return;
            }
            results = response.data.results;
            timestamp_end = response.data.timestamp_end;
            deleted_uids = response.data.deleted_uids || [];
            if(response.data.num_total_pages > 1){
                // i = 2 car la pagination commence à partir de la page 2, la page 1 étant fait dans la premiere requete en await
                for(let i = 2; i <= response.data.num_total_pages; i++){
                    url = response.data.next.replace(/page=\d+/, `page=${i}`);
                    promises.push(context.dispatch('remoteGet', {url, config}));
                }
            }
            Promise.all(promises).then((responses) => {
                for(let response of responses){
                    results = results.concat(response.data.results);
                    timestamp_end = response.data.timestamp_end;
                    deleted_uids = deleted_uids.concat(response.data.deleted_uids);
                }
                resolve({
                    results,
                    deleted_uids,
                    timestamp_end,
                });
            });
        });
    },

    async remoteGet (context, {url, config={}}){

        return new Promise(async (resolve, reject) => {
            this.axios.get(url, config).then((data) => {
                resolve(data);
            }).catch(async (error) => {
                // Si on veut garder le bon fonctionnement de l'appli avec des erreurs contrôlées on resolve avec le mot 'ignored'
                if (isError404(error)) {
                    if(url.includes('concrete-role') || url.includes('concrete-permission')){
                        // Return empty response
                        hasPermsModels = false;
                        resolve('ignored');
                    }
                    if((context.getters.showAlarms || context.getters.showAlerts) && (url.includes('alarm') || url.includes('alert'))){
                        // Return empty response
                        resolve('ignored');
                    }
                    if(url.includes('acl/role') || url.includes('acl/permission')){
                        // Return empty response
                        resolve('ignored');
                    }
                }
                if(Axios.isCancel(error)){
                    reject(error);
                }
                else if (isError403(error)) {
                    // Return empty response
                    resolve('ignored');
                }
                else if(isError500(error)){
                    // Stay in while loop = retry
                    await wait(15);
                    this.remoteGet(url, config);
                }

                if(Axios.isCancel(error)){
                    reject(error);
                }
                let errorMessage = `ERROR while GET on ${url}: ${error}`;
                if(error.status){
                    errorMessage = `ERROR while GET on ${url} has return a ${error.status}`;
                }
                reject(errorMessage);
            });

        });
    },

    async fetchSelfUser (context){
        return context.dispatch('remoteGet', {url: 'account/me/'})
            .then(response => {
                context.commit(
                    'UPDATE_SELF_USER',
                    response.data,
                );
            });
    },

    cancelFetchModelsPeriodically({state, dispatch}, models=null){
        if(!models){
            models = state.meta.listModels;
        }
        for(let modelName in models){
            if(models[modelName].fetch === false) continue;
            dispatch('cancelFetchModelPeriodically', modelName);
        }
    },

    cancelFetchModelPeriodically({state, commit}, modelName){
        clearTimeout(state.modelsFetchHandler[modelName]);
        commit('UPDATE_MODEL_FETCH_HANDLER', {modelName, handler: null});
    },

    async fetchCurrentUserPeriodically({dispatch, commit}){
        let fetchSelfUser = () => {
            dispatch('fetchSelfUser').catch(error => {
                if(!Axios.isCancel(error)){
                    console.error(error);
                }
            }).finally(() =>{
                let handler = setTimeout(fetchSelfUser, 60000);
                commit('UPDATE_MODEL_FETCH_HANDLER', { modelName: 'AccountMe', handler});
            });
        };
        fetchSelfUser();
        return Promise.resolve();
    },

    async fetchModelsPeriodically({state, commit, dispatch}, models=null){
        let defaultPeriod = state.meta.default.fetchModelsPeriod;
        if(isNaN(defaultPeriod)){
            console.warn('No periodically fetch of models');
            return;
        }

        let fetchModel = (modelName, period) => {
            // Add or Subs 20% of value
            let periodWithVariation = Math.floor(
                period * (0.8 + Math.random() * 0.4)
            );
            // Cancel periodically fetch if already exists
            // OPTIM A ACTIVER QUAND COMMANDÉE
            //if(state.modelsFetchHandler[modelName]){
            dispatch('cancelFetchModelPeriodically', modelName);
            //}
            dispatch('fetchModelByName', modelName).finally(() => {
                let handler = setTimeout(
                    () => {fetchModel(modelName, period);},
                    periodWithVariation
                );
                commit('UPDATE_MODEL_FETCH_HANDLER', { modelName, handler});
            });
        };

        if(!models){
            models = state.meta.listModels;
        }

        for(let modelName in models){
            if(models[modelName].fetch === false) continue;
            let period = models[modelName].fetchPeriod || defaultPeriod;
            fetchModel(modelName, period);
        }

        return Promise.resolve();
    },

    removeLocalData (){
        return LocalForage.clear();
    },
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/fundation-app-vuejs/src/concretejs/store/module-api/actions.js
// module id = null
// module chunks = 